export const COLORS = ['R', 'G', 'B', 'Y'];
/**
 * A type predicate rather than a boolean expression at each call site. Writing
 * `card.kind === 'wild' || card.kind === 'wild4'` inline does NOT narrow the
 * union in the branches that follow, so reading `card.color` afterwards fails to
 * compile - a trap this codebase walked into three separate times.
 */
export function isWild(card) {
    return card.kind === 'wild' || card.kind === 'wild4';
}
/**
 * What a host who picks nothing gets: plain UNO with no house rules, and the official
 * drawn-card rule in force.
 *
 * `playDrawnCard: true` is deliberately the odd one out. The `false`s are not a pattern
 * to follow - they mark the three optional house rules, while this one is the rulebook.
 */
export const DEFAULT_TABLE_RULES = {
    liar: false,
    sevenZero: false,
    jumpIn: false,
    playDrawnCard: true,
};
export const ok = (value) => ({ okay: true, value });
export const err = (error) => ({ okay: false, error });
//# sourceMappingURL=types.js.map